import { alertEventsMap } from '../../../../Alerts/constants/alertEventsMap';
import AlertsConfigItem from '../AlertsConfigItem/AlertsConfigItem';
import Tabs from '../../../../../components/common/Tabs/Tabs';

type Props = {
  deviceId: string;
  fleetId: string;
  isOnline: boolean;
  toggleModal: (closed: boolean) => void;
};

const hideAlerts = ['DevStreamEventLdw', 'DevStreamEventAccidentCameraRemoval', 'DevStreamEventCameraBlockage']; // TODO: remove this when the alerts are implemented

function AlertsConfig({
  deviceId, fleetId, isOnline, toggleModal,
}: Props): JSX.Element {
  const setTabs = (): any => {
    const tabs = Object.entries(alertEventsMap)
      .filter(([name]) => !hideAlerts.includes(name)) // Filter out alerts we want to hide
      .map(([name, alert]) => {
        const baseFields = [
          {
            name: 'alertCreate',
            label: 'Enable alert generation',
            text: false,
            defaultValue: true,
            placeholder: 'Check value',
            type: undefined,
          },
        ];

        const extraFields: any[] | undefined = [];
        // You can uncomment and adjust the following switch statement to customize the alert settings further
        // switch (name) {
        //   case 'DevStreamEventOverspeed':
        //     extraFields.push({
        //       name: 'vehicleSpeedLimit',
        //       label: 'Vehicle Speed Limit (km/h)',
        //       text: true,
        //       defaultValue: 90,
        //       placeholder: '5-200 km/h',
        //       type: 'number',
        //     });
        //     break;
        //   // Add additional cases for other alerts
        //   default:
        //     break;
        // }

        const fields = baseFields.concat(extraFields);

        const config = (
          <AlertsConfigItem
            key={name}
            name={name}
            deviceId={deviceId}
            fleetId={fleetId}
            label={alert.shortDesc}
            isOnline={isOnline}
            toggleModal={toggleModal}
            fields={fields}
          />
        );

        return {
          label: alert.badge,
          id: name,
          content: config, // Directly return JSX content for the tab
        };
      });
    return tabs;
  };

  const tabsContent = setTabs();

  return (
    <Tabs
      tabs={tabsContent}
    />
  );
}

export default AlertsConfig;
